import { useEffect, useState } from "react";
import { Divider, Flex } from "antd";
import { Button } from "ui";
import { useGetRobots, useUpdateRobots } from "../api";
import TextArea from "antd/es/input/TextArea";

export const RobotsSettings = () => {
  const [text, setText] = useState<string>("");

  const { data } = useGetRobots();
  const { mutate, isPending: updating } = useUpdateRobots();

  useEffect(() => {
    if (data) setText(data?.data);
  }, [data]);

  return (
    <div className="box">
      <h1>ویرایش فایل Robots</h1>
      <Divider />
      <TextArea
        className={'dir-ltr'}
        autoSize={{ minRows: 30 }}
        value={text}
        onChange={(e) =>
          setText(e.target.value)
        }
      />
      <Divider />
      <Flex justify="flex-end" gap={10}>
        <Button size="large">لغو کردن</Button>
        <Button
          type="primary"
          size="large"
          loading={updating}
          onClick={() => mutate({ text })}
        >
          ذخیره تغییرات
        </Button>
      </Flex>
    </div>
  );
};
